module.exports = __webpack_public_path__ + "img/email.76e805cf.svg";